import { getErrorsFromConditions } from '@/common/components/ConditionsEditor/helpers'

import { errorTypes } from './constants'

const validateConditions = conditions => {
  if (!conditions?.length) return [{ type: errorTypes.conditionsEmpty }]

  return getErrorsFromConditions(conditions)
}

export const validateVisibilityCriterion = criterion => {
  const errors = []

  if (!criterion.name?.trim()) errors.push({ type: errorTypes.nameEmpty })

  errors.push(...validateConditions(criterion.conditions))

  return errors
}
